const readShareH5BaseLink = (raw: string | undefined): string => {
  if (!raw || !raw.trim()) {
    return ''
  }
  try {
    const parsed = JSON.parse(raw) as { shareH5BaseLink?: unknown }
    return typeof parsed.shareH5BaseLink === 'string'
      ? parsed.shareH5BaseLink.trim()
      : ''
  } catch {
    return ''
  }
}

/** Footer / 分享用短 key → HashRouter 内真实 path（与 buyer-web App.tsx Routes 一致） */
const SHARE_PAGE_ROUTE_BY_KEY: Record<string, string> = {
  'trading-rules': '/h5/trading-rules',
  'user-agreement': '/h5/user-agreement',
  'policy-statement': '/h5/policy-statement',
  'personal-information-protect': '/webview/personal-information-protect',
  'privacy-policy': '/webview/privacy-policy',
}

export const buildSharePageUrl = (
  configs: Map<string, string>,
  path: string
): string => {
  const key = path.replace(/^\/+/, '')
  const routePath =
    SHARE_PAGE_ROUTE_BY_KEY[key] ?? (key ? `/${key}` : '/')
  const domain = readShareH5BaseLink(configs.get('sharePageDomain')).replace(
    /\/+$/,
    ''
  )
  if (!domain) {
    return `#${routePath}`
  }
  return `${domain}/#${routePath}`
}
